export default (num: number | string): string => {
  return num.toString().replace(/\./g, ',');
};
